var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFillDripSolid = function SvgFillDripSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3 3.3 9.9 4.7l1.8 1.8-6.9 6.9a3.017 3.017 0 0 0 0 4.3l.1.1 6.3 6.3c1.2 1.2 3.1 1.2 4.3 0l7.6-7.6.7-.7-9.7-9.7-.8-.8-.2-.2zm1.8 4.6 7.9 7.9-2.2 2.2H7.899L6.2 16.3c-.4-.4-.4-1.1 0-1.5zM25 19.3l-.8 1.2s-.5.8-1.1 1.7c-.3.5-.5.9-.7 1.4s-.4.8-.4 1.4c0 1.6 1.4 3 3 3s3-1.4 3-3c0-.6-.2-1-.4-1.5s-.5-1-.7-1.4c-.5-.9-1.1-1.7-1.1-1.7z"
  })));
};
export default SvgFillDripSolid;